// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.AuqsabKKWtCXKFbKHiQ2 {
  width: 100%;
}
table.AuqsabKKWtCXKFbKHiQ2 th .DeJnZ3vUrWpSZXtsoUJ8 {
  height: 1rem;
  width: 1rem;
}

.lFJd1nYHcw7wrfVKqOLi {
  overflow: auto;
}

.mXltElhODM8LiWFtqt38 {
  position: sticky;
  top: 0;
  z-index: 1;
}
.mXltElhODM8LiWFtqt38 .YNBqK9wD7Y86zgyuoCOw {
  border-bottom: 2px solid var(--bs-border-color);
}

.YNBqK9wD7Y86zgyuoCOw {
  overflow-x: scroll;
  white-space: nowrap;
  font-weight: 400;
  height: 20px;
}

.L8wF3gSAjTKLbqt9OE1N {
  width: 100%;
  display: flex;
  justify-content: center;
}

.ab8HKnBbyNuNK0Hk36SC:hover,
.SVvZet1bzCj7cmJcNLEe {
  border-color: #7a7a7a !important;
}

.UkGqjSWOHLuu_BPZH7cj {
  margin-left: 0.5rem;
}

.M9ZFp5eenbCUJXMA4Ogo {
  opacity: 0.5;
  cursor: default !important;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/pages/admin/project/segment/script/list/ScriptTable/ScriptTable.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACI;EACE,YAAA;EACA,WAAA;AACN;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AADF;AAEE;EACE,+CAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AADF;;AAIA;;EAEE,gCAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,YAAA;EACA,0BAAA;EACA,oBAAA;AADF","sourceRoot":""}]);
// Exports
var _1 = `AuqsabKKWtCXKFbKHiQ2`;
export { _1 as "common-table" };
export var icon = `DeJnZ3vUrWpSZXtsoUJ8`;
var _2 = `lFJd1nYHcw7wrfVKqOLi`;
export { _2 as "table-wrapper" };
var _3 = `mXltElhODM8LiWFtqt38`;
export { _3 as "table-header" };
export var cell = `YNBqK9wD7Y86zgyuoCOw`;
var _4 = `L8wF3gSAjTKLbqt9OE1N`;
export { _4 as "table-footer" };
export var isSortable = `ab8HKnBbyNuNK0Hk36SC`;
export var isCurrentSort = `SVvZet1bzCj7cmJcNLEe`;
export var tableIcon = `UkGqjSWOHLuu_BPZH7cj`;
var _5 = `M9ZFp5eenbCUJXMA4Ogo`;
export { _5 as "disabled-row" };
export default ___CSS_LOADER_EXPORT___;
